import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class MessageApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    listMessages() {
        return axios.get(`${URL_API}/plataforma/listar-salve`, this.getConfig())
    }

    getMessage(id) {
        return axios.get(`${URL_API}/plataforma/ler-salve/${id}`, this.getConfig())
    }

    sendMessage(data) {
        return axios.post(`${URL_API}/plataforma/mandar-salve`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    deleteMessages(data) {
        return axios.post(`${URL_API}/plataforma/excluir-salve`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/platform/messages/MessageApi.js